import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";

const DisplayEnteredData = ({ data, onDelete }) => {
  if (!data) return null;
  // console.log("123", data);

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Added Questions
      </Typography>

      {data.map((questionData, index) => (
        <Box
          key={index}
          sx={{
            mt: 3,
            p: 3,
            bgcolor: "#e3f2fd",
            borderRadius: 2,
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => onDelete(index)}
            sx={{ position: "absolute", top: 8, right: 8 }}
            color="error"
          >
            <Delete />
          </IconButton>
          {/* Display Answer */}
          <Typography variant="h6" sx={{ mt: 2, color: "green" }}>
            ✅ Tags: {questionData.tags}
          </Typography>

          <Typography variant="h6">Question {index + 1}:</Typography>

          {/* Display Question Texts */}
          {[
            {
              label: "🇬🇧 English",
              value:
                questionData.questionType[0].question_type === 1
                  ? questionData.questionEnglish[0]?.question_type_text || ""
                  : questionData.questionType[0].question_type === 2
                  ? questionData.questionEnglish[0]?.question_type_link || ""
                  : (questionData.questionEnglish[0]?.question_type_text ||
                      "") +
                    "\n" +
                    (questionData.questionEnglish[0]?.question_type_link || ""),
            },
            {
              label: "🇮🇳 Hindi",
              value:
                questionData.questionType[0].question_type === 1
                  ? questionData.questionHindi[0]?.question_type_text || ""
                  : questionData.questionType[0].question_type === 2
                  ? questionData.questionHindi[0]?.question_type_link || ""
                  : (questionData.questionHindi[0]?.question_type_text || "") +
                    "\n" +
                    (questionData.questionHindi[0]?.question_type_link || ""),
            },
            {
              label: "🇮🇳 Marathi",
              value:
                questionData.questionType[0].question_type === 1
                  ? questionData.questionMarathi[0]?.question_type_text || ""
                  : questionData.questionType[0].question_type === 2
                  ? questionData.questionMarathi[0]?.question_type_link || ""
                  : (questionData.questionMarathi[0]?.question_type_text ||
                      "") +
                    "\n" +
                    (questionData.questionMarathi[0]?.question_type_link || ""),
            },
          ].map((q, i) =>
            q.value ? (
              <Typography key={i}>
                {q.label}: {q.value}
              </Typography>
            ) : null
          )}

          {/* Display Options */}
          <Typography variant="h6" sx={{ mt: 2 }}>
            Options:
          </Typography>
          {questionData.options.map((option, optIndex) => {
            const optionLabel = `Option ${String.fromCharCode(65 + optIndex)}`;
            if (option[`option${optIndex + 1}_type`] === "") return null; // Skip if option type is undefined
            const optionTexts = [
              {
                label: "🇬🇧 English",
                value:
                  option[`option${optIndex + 1}_type`] == 1
                    ? option[`option${optIndex + 1}_type_text_english`] || ""
                    : option[`option${optIndex + 1}_type`] == 2
                    ? option[`option${optIndex + 1}_type_link_english`] || ""
                    : (option[`option${optIndex + 1}_type_text_english`] ||
                        "") +
                      "\n" +
                      (option[`option${optIndex + 1}_type_link_english`] || ""),
              },
              {
                label: "🇮🇳 Hindi",
                value:
                  option[`option${optIndex + 1}_type`] == 1
                    ? option[`option${optIndex + 1}_type_text_hindi`] || ""
                    : option[`option${optIndex + 1}_type`] == 2
                    ? option[`option${optIndex + 1}_type_link_hindi`] || ""
                    : (option[`option${optIndex + 1}_type_text_hindi`] || "") +
                      "\n" +
                      (option[`option${optIndex + 1}_type_link_hindi`] || ""),
              },
              {
                label: "🇮🇳 Marathi",
                value:
                  option[`option${optIndex + 1}_type`] == 1
                    ? option[`option${optIndex + 1}_type_text_marathi`] || ""
                    : option[`option${optIndex + 1}_type`] == 2
                    ? option[`option${optIndex + 1}_type_link_marathi`] || ""
                    : (option[`option${optIndex + 1}_type_text_marathi`] ||
                        "") +
                      "\n" +
                      (option[`option${optIndex + 1}_type_link_marathi`] || ""),
              },
            ];

            const hasValues = optionTexts.some((opt) => opt.value); // Check if at least one language has a value

            return hasValues ? (
              <Box
                key={optIndex}
                sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}
              >
                <Typography variant="h6">{optionLabel}:</Typography>
                {optionTexts.map((opt, idx) =>
                  opt.value ? (
                    <Typography key={idx}>
                      {opt.label}: {opt.value}
                    </Typography>
                  ) : null
                )}
              </Box>
            ) : null;
          })}

          {/* Display Answer */}
          <Typography variant="h6" sx={{ mt: 2, color: "green" }}>
            ✅ Correct Answer: {questionData.answer}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default DisplayEnteredData;
